const API_URL = process.env.REACT_APP_API_URL;

export async function fetchTestsByText(query) {
  try {
    const response = await fetch(`${API_URL}/search?q=${query}`);

    return response.json();
  } catch {
    throw new Error('Failed to fetch tests');
  }
}

export async function fetchTestsByTags(query) {
  try {
    const response = await fetch(`${API_URL}/listByTag?tags=${query}`);

    return response.json();
  } catch {
    throw new Error('Failed to fetch tests');
  }
}

export async function fetchTestsByTestTool(query) {
  try {
    const response = await fetch(`${API_URL}/listByTestTool?testTool=${query}`);

    return response.json();
  } catch {
    throw new Error('Failed to fetch tests');
  }
}

export async function fetchTestsPlansByBuild(query) {
  try {
    const response = await fetch(`${API_URL}/listByBuild?build=${query}`);

    return response.json();
  } catch {
    throw new Error('Failed to fetch test plans');
  }
}

export async function fetchPlansByCodestream(codestream) {
  try {
    const response = await fetch(
      `${API_URL}/listByCodestream?codestream=${encodeURIComponent(codestream)}`
    );
    return response.json();
  } catch {
    throw new Error('Failed to fetch plans by codestream');
  }
}

export async function fetchPlansBySquad(squad) {
  try {
    const response = await fetch(
      `${API_URL}/listBySquad?squad=${encodeURIComponent(squad)}`
    );
    return response.json();
  } catch {
    throw new Error('Failed to fetch plans by squad');
  }
}

export async function fetchGeneratedTestPlansByCodestream(codestream) {
  const response = await fetch(
    `${API_URL}/generateTestPlanByCodestream?codestream=${encodeURIComponent(codestream)}`
  );

  const contentType = response.headers.get('content-type');
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`API error ${response.status}: ${text}`);
  }

  if (!contentType || !contentType.includes('application/json')) {
    const text = await response.text();
    throw new Error(`Expected JSON but got: ${text}`);
  }

  return response.json();
}

export async function fetchCatalogEntry(testName) {
  try {
    const response = await fetch(`${API_URL}/${encodeURIComponent(testName)}`);

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`API error ${response.status}: ${text}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Expected JSON but got: ${text}`);
    }

    return response.json();
  } catch (err) {
    throw new Error(`Failed to fetch catalog entry: ${err.message}`);
  }
}
export async function fetchAISuggestion(featureDescription) {
  try {
    const response = await fetch(`${API_URL}/getAIsuggestion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ featureDescription }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`AI API error ${response.status}: ${text}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Expected JSON but got: ${text}`);
    }

    const result = await response.json();
    return result.summary || 'No summary returned by AI.';
  } catch (err) {
    throw new Error(`Failed to fetch AI suggestion: ${err.message}`);
  }
}
